import React, { Component } from "react";
import "./style.css";
import Pages from "./Pages";
import { Splitter } from "@progress/kendo-react-layout";
import ServerError from "../Shared/Error/ServerError";
import Components from "./Components.jsx";
import { ComponentsContextProvider } from "../../Context/Display/Components/ComponentsContext";
import EditComponentForm from "./EditComponentForm/EditComponent";
import { ConfirmationContextProvider } from "../Shared/ConfirmationWithContext/ConfirmationContext";
import { ComponentPropertiesProvider } from "../../Context/Display/ComponentProperties/ComponentPropertiesContext";

class DisplayComponents extends Component {
    render() {
        return (
            <ComponentsContextProvider>
                <ConfirmationContextProvider>
                    <ComponentPropertiesProvider>
                        <Splitter
                            panes={[
                                { size: "20%", min: "20px", collapsible: false },
                                { size: "23%", min: "20px", collapsible: false },
                            ]}
                        >
                            <div className="h-100" style={{ overflow: "hidden" }}>
                                <Pages />
                            </div>
                            <div className="component-splitter">
                                <Components />
                            </div>
                            <div className="component-form h-100">
                                <EditComponentForm />
                            </div>
                        </Splitter>
                    </ComponentPropertiesProvider>
                </ConfirmationContextProvider>
            </ComponentsContextProvider>
        );
    }
}

export default DisplayComponents;
